export async function retryRequest(fn, maxAttempts = 4, delayMs = 500) {
  let lastError;
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn();
    } catch (err) {
      const message = err?.message?.toLowerCase?.() || '';
      if (!message.includes('load failed') || attempt === maxAttempts) {
        throw err;
      }
      console.warn(`Retry ${attempt} failed: ${message}`);
      lastError = err;
      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
  }
  throw lastError;
}
